export default {
  orders: "Orders",
};
